import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { dateDifference } from './common';
import { MIN_AGE, MIN_ALLOWED_DATE } from './constants';

dayjs.extend(customParseFormat);

const phoneValidationRegex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

const validateMinAge = (date: string): boolean =>
  dateDifference(dayjs(), date) >= MIN_AGE;

const validateDate = (
  date: string | Dayjs | Date,
  format = 'MM/DD/YYYY',
  strict = true,
): boolean => dayjs(date, format, strict).isValid();

const isDateInPast = (date: string | Dayjs | Date): boolean =>
  dayjs().isAfter(date);

const isOldestDateCrossed = (date: string): boolean =>
  dayjs()
    .year(MIN_ALLOWED_DATE - 1)
    .month(11)
    .date(31)
    .isBefore(dayjs(date), 'month');

export {
  phoneValidationRegex,
  validateMinAge,
  validateDate,
  isDateInPast,
  isOldestDateCrossed,
};
